let getTheme = () => 'cary';
let getBundler = () => 'rollup';


export function setupLoader(_getBundler: () => 'rollup' | 'webpack', _getTheme: () => string) {
  getBundler = _getBundler;
  getTheme = _getTheme;
}


export async function loadIcon(iconName: string): Promise<any> {
  if (!iconName) {
    return Promise.reject('No iconName provided.');
  }
  const loadFunction = await import(`./loaders/${getBundler()}.loader.js`);
  return await loadFunction.default('icon', iconName, getTheme());
}

export async function loadFlag(iconName: string): Promise<any> {
  if (!iconName) {
    return Promise.reject('No flagName provided.');
  }
  const loadFunction = await import(`./loaders/${getBundler()}.loader.js`);
  return await loadFunction.default('icon', iconName, 'flags');
}

export async function loadIssuer(issuerName: string): Promise<any> {
  if (!issuerName) {
    return Promise.reject('No issuerName provided.');
  }
  const loadFunction = await import(`./loaders/${getBundler()}.loader.js`);
  return await loadFunction.default('issuer', issuerName, getTheme());
}
